export class UpsellModel {
  constructor() {
    this.campaign = {
      products: [],
    };
    this.default_side = 'FRONT';
  }
};